export default {
  BusinessQuotation: {
    title: 'Quotation Account Information',
    code: 'Quotation Number',
    quotationType: 'Quotation Type',
    countryCode: 'Quoting Country',
    createdName: 'Quotation Issuer',
    errMsg1: 'The length, width, height, and weight of the product cannot be 0. Please make the necessary changes before proceeding.',
    errMsg2: 'The required fields in the table cannot be left blank, and numeric values must not be zero. Please fill in the information carefully.',
    errMsg3: 'This operation will reset and clear the product information. Please confirm.',
    errMsg4: 'SKU cannot be empty',
    errMsg5: 'Please select the country of shipment.',
    errMsg6: 'Please create the SKU and save it successfully before proceeding to review',
    errMsg7: 'Please select data with the status \'Completed\'.',
    errMsg8: 'The pallet quantity does not match the volume of this PO.',
    time: 'Quotation Time Range',
    estima: 'Profit Margin Range',
    abandonQuotation: 'Discard Quotation',
    convertToPO: 'Convert to Purchase Order',
    creationDate: 'Quotation Time',
    status: 'Quotation Status',
    sapSkuBtn: 'Manual Sync SAP-SKU',
    sapSkuData: 'Synchronization Date',
    hintMsg: 'Please select the synchronization date',
    saveDraft: 'Save as Draft',

    table: {
      select: 'Select',
      countryCode: 'Country',
      temporaryCode: 'Temporary SKU',
      planQty: 'Recommended Order Quantity',
      exchangeRate: 'Exchange Rate',
      cnPurchasePrice: 'CNY Purchase Price',
      foreignPurchasePrice: 'Foreign Currency Purchase Price',
      price: 'Estimated Selling Price',
      refundResendPrice: 'After-sales Amount',
      totalVolume: 'Total Volume',
      consumptionTaxName: 'GST / VAT',
      actualConsumptionTax: 'Consumption Tax',
      importTariffs: 'Import Duty',
      importTariffsPercentage: 'Import Duty Percentage',
      ebayPaypalPrice: 'Platform Fee',
      laborPrice: 'Labor Cost ',
      expressPrice: 'Total Postage',
      postageSurcharge: 'Postage Surcharge',
      courier: 'Courier',
      seaInlandFreight: 'Ocean Freight',
      storagePrice: 'Storage Fee',
      surcharge: 'Peak Season Surcharge',
      brandName: 'Brand Name',
      estimatedProfit: 'Estimated Profit',
      estimatedProfitRate: 'Profit Margin',
      powerSupplyMode: 'Power Supply Method',
      linkUrl: 'Reference Product Link',
      skuImg: 'Image',
      categoryName: 'Product Category',
      length: 'Unit Length',
      width: 'Unit Width',
      height: 'Unit Height',
      weight: 'Unit Weight',
      volume: 'Unit Volume',
      singleMultiComponentProduct: 'Is the product composed of multiple components',
      qty: 'Unit Qty per Carton',
      cartonLength: 'Carton Length',
      cartonWidth: 'Carton Width',
      cartonHeight: 'Carton Height',
      cartonWeight: 'Carton Weight',
      cartonVolume: 'Carton Volume',
      specification: 'Product Parameters',
      differentiatedSellingPoints: 'Unique Selling Points',
      brandTooltip: 'Required for New Products',
      importTariffsTooltip: 'UK Product Import Duty Required',
      create: 'Create SKU'
    }
  }
};
